import React, { useState } from 'react';
import InputMask from 'react-input-mask';
import './CustomInput.scss';

const CustomInput = ({
                         label,
                         placeholder,
                         disabled,
                         onChange,
                         value,
                         leftSlot,
                         rightSlot,
                         leftSlotOnClick,
                         rightSlotOnClick,
                         type,
                         max,
    onKeyDown,
                     }) => {
    const [inputIsFocus, setInputIsFocus] = useState(false);
    const [internalDateValue, setInternalDateValue] = useState(value);

    const handleChange = (event) => {
        const newValue = event.target.value;
        if (type === 'date') {
            setInternalDateValue(newValue);
        } else {
            onChange(newValue);
        }
    };

    const handleDateKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            onChange(internalDateValue);
            if (onKeyDown) {
                onKeyDown(event);
            }
        }
    };

    return (
        <div className={`v2-input-div`}>
            {label && <p className={'body-3 c-text-subtitle'}>{label}</p>}
            <div className={`v2-input-container ${inputIsFocus && 'v2-input-container-focus'}  ${disabled && 'v2-out-input-disabled'}`}>
                {leftSlot && (
                    <div onClick={leftSlotOnClick} className='flex-aligned-justified-center cursor-pointer'>
                        {leftSlot}
                    </div>
                )}
                {type === 'cuit' ? (
                    <InputMask
                        className={`v2-input-tag body-1 c-text-base ${disabled && 'v2-in-input-disabled'}`}
                        onFocus={() => setInputIsFocus(true)}
                        value={value}
                        mask="99-99999999-9"
                        maskChar=""
                        onBlur={() => setInputIsFocus(false)}
                        onChange={handleChange}
                        onKeyDown={onKeyDown}
                        placeholder={placeholder}
                        disabled={disabled}
                    />
                ) : type === 'credential' ? (
                    <InputMask
                        mask="a999999/999"
                        maskChar={null}
                        value={value}
                        onChange={(event) => {
                            const formattedValue = event.target.value.toUpperCase();
                            onChange(formattedValue);
                        }}
                        onBlur={() => setInputIsFocus(false)}
                        onFocus={() => setInputIsFocus(true)}
                        onKeyDown={onKeyDown}
                        className={`v2-input-tag body-1 c-text-base ${disabled && 'v2-in-input-disabled'}`}
                        placeholder="E999999/999"
                        disabled={disabled}
                    />
                ) : type === 'date' ? (
                    <input
                        onFocus={() => setInputIsFocus(true)}
                        value={internalDateValue}
                        type="date"
                        max={max || ''}
                        onBlur={() => setInputIsFocus(false)}
                        onChange={handleChange}
                        onKeyDown={handleDateKeyDown}
                        className={`v2-input-tag body-1 c-text-base ${disabled && 'v2-in-input-disabled'}`}
                        placeholder={placeholder}
                        disabled={disabled}
                    />
                ) : (
                    <input
                        onFocus={() => setInputIsFocus(true)}
                        value={value}
                        type={type || 'text'}
                        max={max || ''}
                        onBlur={() => setInputIsFocus(false)}
                        onChange={handleChange}
                        onKeyDown={onKeyDown}
                        className={`v2-input-tag body-1 c-text-base ${disabled && 'v2-in-input-disabled'}`}
                        placeholder={placeholder}
                        disabled={disabled}
                    />
                )}
                {rightSlot && (
                    <div onClick={() => {
                        if (type === 'date') {
                            onChange(internalDateValue);
                        }
                        if (rightSlotOnClick) {
                            rightSlotOnClick();
                        }
                    }} className='flex-aligned-justified-center cursor-pointer'>
                        {rightSlot}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CustomInput;
